import React, {useState} from 'react';

const ModalBusqueda = ({ resultadosBusqueda, onSeleccionarPropiedad, onCerrarModal }) => {

  const [filtroActivo, setFiltroActivo] = useState('todos');

  // Calcular conteos
  const conteoTotal = resultadosBusqueda.length;
  const conteoAgricola = resultadosBusqueda.filter(p => p.agr === 1).length;
  const conteoNoAgricola = resultadosBusqueda.filter(p => p.agr === 0).length;

  // Filtrar resultados según selección
  const resultadosFiltrados = filtroActivo === 'agricola'
    ? resultadosBusqueda.filter(p => p.agr === 1)
    : filtroActivo === 'no_agricola'
    ? resultadosBusqueda.filter(p => p.agr === 0)
    : resultadosBusqueda;

  return (
    <div className="modal-overlay">
        <div className="modal">

            <h2>Resultados de la búsqueda por dirección</h2>


            {/* Filtros */}
            <div style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '20px',
                margin: '10px 0',
                //fontStyle: 'italic',
                fontSize: '0.8rem'
            }}>
          <span
              style={{
                  cursor: 'pointer',
                  color: filtroActivo === 'todos' ? '#007bff' : '#555'
              }}
              onClick={() => setFiltroActivo('todos')}
          >
            Mostrar todo ({conteoTotal})
          </span>
                <span
                    style={{
                        cursor: conteoNoAgricola > 0 ? 'pointer' : 'default',
                        color: filtroActivo === 'no_agricola' ? '#007bff' : conteoNoAgricola > 0 ? '#555' : '#ccc'
                    }}
                    onClick={conteoNoAgricola > 0 ? () => setFiltroActivo('no_agricola') : undefined}
                >
            No agrícola ({conteoNoAgricola})
          </span>
                <span
                    style={{
                        cursor: conteoAgricola > 0 ? 'pointer' : 'default',
                        color: filtroActivo === 'agricola' ? '#007bff' : conteoAgricola > 0 ? '#555' : '#ccc'
                    }}
                    onClick={conteoAgricola > 0 ? () => setFiltroActivo('agricola') : undefined}
                >
            Agrícola ({conteoAgricola})
          </span>
            </div>


            {resultadosFiltrados.length > 0 ? (
                <div className="contenido-modal">
                    <table className="tabla-resultados">
                        <thead>
                        <tr>
                            <th>Rol</th>
                            <th>Dirección</th>

                        </tr>
                        </thead>
                        <tbody>
                        {resultadosFiltrados.map((propiedad) => (
                            <tr
                                key={`${propiedad.manzana}-${propiedad.predio}`}
                                className="fila-resultado"
                                onClick={() => onSeleccionarPropiedad(propiedad)}
                            >
                                <td>{propiedad.manzana}-{propiedad.predio}</td>
                                <td>{propiedad.direccion}</td>

                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <>
                    <p>No se encontraron
                        resultados {filtroActivo !== 'todos' ? `para ${filtroActivo === 'agricola' ? 'agrícolas' : 'no agrícolas'}` : ''}.</p>
                </>
            )}


            <div style={{
                margin: '20px 0',
                padding: '10px',
                backgroundColor: '#f8f9fa',
                borderRadius: '4px',
                fontSize: '0.9rem',
                color: '#555'
            }}>
                <p>Si no encuentras la dirección que buscas, puede que esté escrita de otra forma en los
                    registros oficiales o que sea muy reciente. Prueba buscando por rol o escribiéndola de otra forma.</p>
            </div>


            <button onClick={onCerrarModal}>Cerrar</button>
        </div>
    </div>
  );
};

export default ModalBusqueda;